import styled from 'styled-components';

const StyledButtonMenuP = styled.button`
  background-color: rgba(128,128,128,0.2);
  border: none;
  color: black;
  padding: 10px 20px;
  text-align: left;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;

  &:hover {
    background-color: #abb2b9;
  }
`;

export default StyledButtonMenuP;